import { useMemo } from "react";
import { useLoggedInWithOrgContextState } from "../auth/useLoggedInWithOrgContextState";
import { columnMemoryFor, type ColumnMemory } from "./columnMemory";

export const useColumnMemory = (table: string): ColumnMemory => {
  const authState = useLoggedInWithOrgContextState();
  const personId = authState.me.id;
  const organizationId = authState.selectedOrg.id;
  return useMemo(() => columnMemoryFor(personId, organizationId, table), [personId, organizationId, table]);
};
